export {
	getFontSize,
	getFontSizeClass,
	getFontSizeObjectByValue,
} from './utils';
export { getComputedFluidTypographyValue } from './fluid-utils';
export { default as FontSizePicker } from './font-size-picker';
export { default as withFontSizes } from './with-font-sizes';
